import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useEffect, useRef, useState } from 'react';
import { useGetOidcAttributeMappingsQuery } from "../../../services/saml/saml-service";
import { defaultFormValues, getDefaultSamlHeaders, getSubDomainIfOrgEnabled, TranslationsKeys, } from '../constant';
import styles from '../identity-details/identity-details.module.scss';
export const OidcIdentityDetails = ({ setScreenLoader, editData, edit, clientId, formDataRef, resetEdit, setAttributeValues, onProviderForm, idpType, formFields, currentOrgInfo, }) => {
    const { t } = useTranslation();
    const getTranslations = (key, args) => t(`${key}`, args);
    const isMountedRef = useRef(true);
    const [queryEnabled, setQueryEnabled] = useState(true);
    const [jitEnabled, setJitEnabled] = useState(true);
    const [hasErrors, setHasErrors] = useState({});
    const [hideForm, setHideForm] = useState(false);
    const handleSubmit = (event) => {
        event.preventDefault();
        const errors = {};
        let isFormInValid = false;
        formFields.forEach(field => {
            const value = formDataRef.current[field.refName];
            const is_invalid = field.is_invalid(value);
            if (is_invalid) {
                errors[field.id] = is_invalid;
                isFormInValid = true;
            }
        });
        if (isFormInValid) {
            setHasErrors(errors);
            return;
        }
        if (!('autoCreateUser' in formDataRef.current)) {
            formDataRef.current.autoCreateUser = true;
        }
        formDataRef.current.type = idpType;
        setHideForm(true);
        onProviderForm(false, false, true, null);
    };
    const { data: mapData, loading: mapLoading, error: mapError, } = useGetOidcAttributeMappingsQuery({
        id: queryEnabled ? editData?.id : undefined,
        clientId,
        defaultHeaders: getDefaultSamlHeaders(),
    });
    useEffect(() => {
        if (edit && (mapData || mapError) && !mapLoading) {
            if (isMountedRef.current) {
                setScreenLoader(false);
            }
            if (mapData) {
                setAttributeValues(mapData.Data);
            }
        }
    }, [mapData, mapLoading, mapError]);
    useEffect(() => {
        if (edit) {
            let subDomain = getSubDomainIfOrgEnabled();
            if (!subDomain && currentOrgInfo) {
                subDomain = `${currentOrgInfo.orgName}_`;
            }
            formDataRef.current = {
                ...formDataRef.current,
                ...editData,
            };
            const name = formDataRef.current.connectionName;
            formDataRef.current.connectionName = subDomain
                ? name.replaceAll(subDomain, '')
                : name;
            formDataRef.current.autoCreateUser = editData.autoCreateUser;
            formDataRef.current.IDPClientId = editData.clientId;
            formDataRef.current.scopes = editData.scopes.join(' ').trim();
            setJitEnabled(formDataRef.current.autoCreateUser);
            if (isMountedRef.current) {
                setScreenLoader(true);
            }
        }
    }, []);
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
            setQueryEnabled(false);
        };
    }, []);
    const cancelChange = () => {
        formDataRef.current = defaultFormValues;
        onProviderForm(true, false, false);
        resetEdit();
    };
    const valueLabels = {
        true: getTranslations(TranslationsKeys.OIDC_JIT_TRUE_LABEL),
        false: getTranslations(TranslationsKeys.OIDC_JIT_FALSE_LABEL),
    };
    return (React.createElement(Vertical, { style: { display: hideForm ? 'none' : '' }, spacing: "c", width: 400 },
        React.createElement(Typography, { variant: "h3", className: styles.marginTop32 }, `${idpType.charAt(0).toUpperCase()}${idpType
            .slice(1)
            .toLowerCase()} ${getTranslations(TranslationsKeys.OIDC_FORM_HEADER)}`),
        React.createElement("form", { onSubmit: handleSubmit },
            formFields.map((field, index) => (React.createElement(FormControl, { key: field.id, label: getTranslations(field.label), hasError: hasErrors[field.id], errorMessage: getTranslations(field.errorText), helpText: hasErrors[field.id]
                    ? getTranslations(field.errorText)
                    : getTranslations(field.helpText) },
                React.createElement(Input.Text, { "data-testid": field.testId, disabled: false, value: formDataRef.current[field.refName], inputClassName: styles.inputField, onChange: (event) => {
                        formDataRef.current[field.refName] =
                            event.target.value;
                    } })))),
            React.createElement(FormControl, { label: getTranslations(TranslationsKeys.OIDC_JIT_LABEL), helpText: getTranslations(TranslationsKeys.OIDC_JIT_HELP_TEXT) },
                React.createElement(Toggle, { id: "noMatchSelectTestId", checked: jitEnabled, onChange: event => {
                        formDataRef.current.autoCreateUser = !jitEnabled;
                        setJitEnabled(!jitEnabled);
                    }, name: "noMatchSelectTestId", label: valueLabels && valueLabels[`${jitEnabled}`], disabled: false, labelPosition: "right" })),
            React.createElement(Horizontal, { spacing: "e", hAlignContent: "left" },
                React.createElement(Vertical, null,
                    React.createElement(Button, { isDisabled: mapLoading, "data-testid": "submit_button", text: getTranslations(TranslationsKeys.CONTINUE), onClick: handleSubmit })),
                React.createElement(Vertical, null,
                    React.createElement(Button, { "data-testid": "oidcCancelButton", type: "secondary", text: getTranslations(TranslationsKeys.CANCEL), onClick: cancelChange }))))));
};
//# sourceMappingURL=oidc-identity-details.container.js.map